import { PostData } from '../types';
import { MediaType } from '../../../../../models/graphql';

export const cropDirectImageStoryTall = (data: PostData) => {
  return (
    data.media &&
    data.media.type === MediaType.PHOTO &&
    data.profileType === 'business' &&
    data.feedType === 'story' &&
    data.publishingMethod === 'DIRECT' &&
    data.media.height > data.media.width &&
    data.media.width / data.media.height < 9 / 16
  );
};
